import {
    Ellipsoid,
    SceneTransforms,
    Viewer,
    CameraEventType,
    HeadingPitchRange,
    Cartesian3,
    Cartographic,
    EllipsoidGeodesic,
    Color,
    ImageMaterialProperty,
    CallbackProperty,
    ColorGeometryInstanceAttribute,
    Primitive,
    EllipsoidGeometry,
    ScreenSpaceEventHandler,
    Math as cesiumMath,
    Matrix4,
    VertexFormat,
    Transforms,
    HeadingPitchRoll,
    viewerCesium3DTilesInspectorMixin,
    HeightReference,
    PostProcessStage,
    freezeObject,
    knockout,
    Matrix3,
    UrlTemplateImageryProvider,
    WebMapTileServiceImageryProvider,
    ArcGisMapServerImageryProvider,
    createOpenStreetMapImageryProvider,
    Entity, DistanceDisplayCondition, Cartesian2
} from 'cesium'
import * as Cesium from 'cesium';

/**
 * 类内部使用
 * WGS84坐标系转笛卡尔坐标系
 * @param point
 * @return {{x: *, y: *, z: *}}
 * @constructor
 */
function WGS84_to_Cartesian3(point) {
    var car33 = Cartesian3.fromDegrees(point.lng, point.lat, point.alt);
    var x = car33.x;
    var y = car33.y;
    var z = car33.z;
    return new Cartesian3(x, y, z);

}




class cesiumUtil {
    constructor(container, options) {
        this.viewer = new Viewer(container, {
            animation: false, //是否创建动画小器件，左下角仪表    
            baseLayerPicker: false, //是否显示图层选择器    
            fullscreenButton: false, //是否显示全屏按钮    
            geocoder: false, //是否显示geocoder小器件，右上角查询按钮    
            homeButton: false, //是否显示Home按钮    
            infoBox: false, //是否显示信息框    
            sceneModePicker: false, //是否显示3D/2D选择器    
            selectionIndicator: false, //是否显示选取指示器组件    
            timeline: false, //是否显示时间轴    
            navigationHelpButton: false, //是否显示右上角的帮助按钮    
            scene3DOnly: true, //如果设置为true，则所有几何图形以3D模式绘制以节约GPU资源   
            imageryProvider:  new Cesium.WebMapTileServiceImageryProvider({
                url: "http://t0.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default&format=tiles&token='42ef0f4a2e24db1930a89bd06cd0a454'",
                layer: "tdtBasicLayer",
                style: "default",
                format: "image/jpeg",
                tileMatrixSetID: "GoogleMapsCompatible",
                show: false
            })
        });
        // 全球光照
        this.viewer.scene.globe.enableLighting = options.sunlight;
        this.viewer.scene.fog.enabled = options.fog;
        // 实体阴影
        this.viewer.shadows = options.shadow;
        // 相机初始化
        this.initialCameraPosition();
        // 鼠标操作初始化
        this.initialMouseOperation();
        this.viewer.scene.screenSpaceCameraController.minimumZoomDistance = 10; //相机的高度的最小值
        this.viewer.scene.screenSpaceCameraController.maximumZoomDistance = 1000000; //相机高度的最大值
        // this.viewer.scene.screenSpaceCameraController._minimumZoomRate = 30000; // 设置相机缩小时的速率
        // this.viewer.scene.screenSpaceCameraController._maximumZoomRate = 5906376272000 //设置相机放大时的速率
    }
    get BNViewer() {
        return this.viewer
    }
    get enableLighting() {
        return this.viewer.scene.globe.enableLighting
    }
    set enableLighting(value) {
        this.viewer.scene.globe.enableLighting = value
    }
    get fog() {
        return this.viewer.scene.fog.enabled
    }
    set fog(value) {
        this.viewer.scene.fog.enabled = value
    }
    get shadows() {
        return this.viewer.shadows
    }
    set shadows(value) {
        this.viewer.shadows = value
    }


    /**
     * 添加场景
     * @param {Viewer} viewer  viewer视图
     * @param {String} type    场景类型
     */
    addStage(type) {
        let stageGlsl = {
            snow: ` uniform sampler2D colorTexture;\n\
                    varying vec2 v_textureCoordinates;\n\
                    \n\
                    float snow(vec2 uv,float scale)\n\
                        {\n\
                            float time = czm_frameNumber / 60.0;\n\
                            float w=smoothstep(1.,0.,-uv.y*(scale/10.));if(w<.1)return 0.;\n\
                            uv+=time/scale;uv.y+=time*2./scale;uv.x+=sin(uv.y+time*.5)/scale;\n\
                            uv*=scale;vec2 s=floor(uv),f=fract(uv),p;float k=3.,d;\n\
                            p=.5+.35*sin(11.*fract(sin((s+p+scale)*mat2(7,3,6,5))*5.))-f;d=length(p);k=min(d,k);\n\
                            k=smoothstep(0.,k,sin(f.x+f.y)*0.01);\n\
                            return k*w;\n\
                        }\n\
                        \n\
                        void main(void){\n\
                            vec2 resolution = czm_viewport.zw;\n\
                            vec2 uv=(gl_FragCoord.xy*2.-resolution.xy)/min(resolution.x,resolution.y);\n\
                            vec3 finalColor=vec3(0);\n\
                            float c = 0.0;\n\
                            c+=snow(uv,30.)*.0;\n\
                            c+=snow(uv,20.)*.0;\n\
                            c+=snow(uv,15.)*.0;\n\
                            c+=snow(uv,10.);\n\
                            c+=snow(uv,8.);\n\
                            c+=snow(uv,6.);\n\
                            c+=snow(uv,5.);\n\
                            finalColor=(vec3(c)); \n\
                            gl_FragColor = mix(texture2D(colorTexture, v_textureCoordinates), vec4(finalColor,1), 0.5); \n\
                        \n\
                        }\n\ `,
            rain: ` uniform sampler2D colorTexture;\n\
                    varying vec2 v_textureCoordinates;\n\
                    \n\
                    float hash(float x){\n\
                        return fract(sin(x*133.3)*13.13);\n\
                    }\n\
                    \n\
                    void main(void){\n\
                    \n\
                        float time = czm_frameNumber / 60.0;\n\
                        vec2 resolution = czm_viewport.zw;\n\
                        \n\
                        vec2 uv=(gl_FragCoord.xy*2.-resolution.xy)/min(resolution.x,resolution.y);\n\
                        vec3 c=vec3(.6,.7,.8);\n\
                        \n\
                        float a=-.4;\n\
                        float si=sin(a),co=cos(a);\n\
                        uv*=mat2(co,-si,si,co);\n\
                        uv*=length(uv+vec2(0,4.9))*.3+1.;\n\
                        \n\
                        float v=1.-sin(hash(floor(uv.x*100.))*2.);\n\
                        float b=clamp(abs(sin(20.*time*v+uv.y*(5./(2.+v))))-.95,0.,1.)*20.;\n\
                        c*=v*b; \n\
                        \n\
                        gl_FragColor = mix(texture2D(colorTexture, v_textureCoordinates), vec4(c,1), 0.5);  \n\
                    }\n\
`,
            fog: `   uniform sampler2D colorTexture;\n\
                    uniform sampler2D depthTexture;\n\
                    varying vec2 v_textureCoordinates;\n\
                    void main(void)\n\
                    {\n\
                        vec4 origcolor=texture2D(colorTexture, v_textureCoordinates);\n\
                        vec4 fogcolor=vec4(0.8,0.8,0.8,0.5);\n\
                        \n\
                        float depth = czm_readDepth(depthTexture, v_textureCoordinates);\n\
                        vec4 depthcolor=texture2D(depthTexture, v_textureCoordinates);\n\
                        \n\
                        float f=(depthcolor.r-0.22)/0.2;\n\
                        if(f<0.0) f=0.0;\n\
                        else if(f>1.0) f=1.0;\n\
                        gl_FragColor = mix(origcolor,fogcolor,f);\n\
                    }\n\
                `
        };
        try {
            if (type && typeof type == 'string') {
                let postProcessStages = this.viewer.scene.postProcessStages;
                let fs_Type = stageGlsl[type];
                let stage = new PostProcessStage({
                    name: `BN_${type}`,
                    fragmentShader: fs_Type
                });
                postProcessStages.add(stage);
                return stage;
            } else {
                throw ''
            }
        } catch (e) {
            console.log('场景类型参数未定义，或者不是要求的字符串类型');
        }

    }

    /**
     * 单点旋转
     */
    enableCameraRotate() {
        let that = this;
        let entity = this.viewer.entities.add({
            position: Cartesian3.fromDegrees(116.60228019, 40.08177682),
            point: {
                color: Color.TRANSPARENT,
                pixelSize: 0
            }
        });
        let initialHeading = 0;
        let step = 0.1;
        let setIntervalID;

        function intervalFn() {
            if (initialHeading > 360) {
                initialHeading = 0;
            }
            var offset = new HeadingPitchRange(cesiumMath.toRadians(initialHeading), -cesiumMath.toRadians(20), 10000);
            that.viewer.zoomTo(entity, offset)
            initialHeading += step;
        }
        setIntervalID = setInterval(intervalFn, step * 1000);
        return setIntervalID;
    }

    /**
     * 移除指定场景
     * @param {Viewer} viewer  viewer视图
     * @param {Stage} stage    场景对象
     */
    removeStage(stage) {
        let postProcessStages = this.viewer.scene.postProcessStages;
        postProcessStages.remove(stage);
    }

    /**
     * 获取鼠标行为坐标
     * @param {*} movement 
     * @param {*} cesiumMath 
     */
    getCoors(movement, cesiumMath) {
            let longitudeString = null;
            let latitudeString = null;
            let height = null;
            let cartesian = null;
            //得到当前三维场景的椭球体
            let ellipsoid = this.viewer.scene.globe.ellipsoid;
            let coors = {};
            //通过指定的椭球或者地图对应的坐标系，将鼠标的二维坐标转换为对应椭球体三维坐标
            try {
                cartesian = this.viewer.camera.pickEllipsoid(movement.endPosition, ellipsoid);
                if (cartesian) {
                    //将笛卡尔坐标转换为地理坐标
                    var cartographic = ellipsoid.cartesianToCartographic(cartesian);
                    //将弧度转为度的十进制度表示
                    longitudeString = cesiumMath.toDegrees(cartographic.longitude);
                    latitudeString = cesiumMath.toDegrees(cartographic.latitude);
                    //获取相机高度
                    height = Math.ceil(this.viewer.camera.positionCartographic.height);
                    coors['lon'] = parseFloat(longitudeString).toFixed(8);
                    coors['lat'] = parseFloat(latitudeString).toFixed(8);
                    coors['atitude'] = height;
                    return coors;
                } else {

                }
            } catch (e) {

            }

        }
        
    /**
     * 初始化场景位置
     */
    initialCameraPosition(lon,lat,height,heading,pitch,roll) {
        this.viewer.scene.camera.setView({
            // 初始化相机经纬度
            destination: new Cartesian3.fromDegrees(lon,lat,height),
            orientation: {
                heading: cesiumMath.toRadians(heading),
                pitch: cesiumMath.toRadians(pitch), //从上往下看为-90
                roll: roll
            }
        });
    }

    /**
     * 初始化鼠标操作
     */
    initialMouseOperation() {
        // 倾斜视图 鼠标左键旋转
        this.viewer.scene.screenSpaceCameraController.tiltEventTypes = [CameraEventType.LEFT_DRAG];
        // 缩放设置 重新设置缩放成员 
        this.viewer.scene.screenSpaceCameraController.zoomEventTypes = [CameraEventType.MIDDLE_DRAG, CameraEventType.WHEEL, CameraEventType.PINCH];
        // 平移 添加鼠标右键  鼠标右键平移
        this.viewer.scene.screenSpaceCameraController.rotateEventTypes = [CameraEventType.RIGHT_DRAG]
    }

    /**
     * 获取相机视点位置
     */
    getCameraPosition() {
        //中心点位置
        var rectangle = this.BNViewer.camera.computeViewRectangle();
        var west = rectangle.west / Math.PI * 180;
        var north = rectangle.north / Math.PI * 180;
        var east = rectangle.east / Math.PI * 180;
        var south = rectangle.south / Math.PI * 180;
        var centerx = (west + east) / 2;
        var cnetery = (north + south) / 2;
        //获取当前相机高度
        let height = Math.ceil(this.BNViewer.camera.positionCartographic.height);
        let position = WGS84_to_Cartesian3({
            lng: centerx,
            lat: cnetery,
            alt: height
        })
        return position
    }


    /**
     * 初始化场景位置
     */
    static initialCameraPosition(viewer,options) {
        viewer.scene.camera.setView({
            // 初始化相机经纬度
            destination: new Cartesian3.fromDegrees(options.lon,options.lat,options.height),
            orientation: {
                heading: cesiumMath.toRadians(options.heading),
                pitch: cesiumMath.toRadians(options.pitch), //从上往下看为-90
                roll: options.roll
            }
        });
    }
    /**
     * 绘制电子围栏
     */
     static createElePolygon(coors,options) {
        let gradeColor={
            3:Color.RED,
            2:Color.ORANGE,
            1:Color.YELLOW,
            0:Color.BLUE
        };
        let _polygon;
        _polygon=new Entity({
        show:true,
        name: options.name,
        polygon: {
            hierarchy: Cartesian3.fromDegreesArray(coors),
            extrudedHeight: options.height,
            material: Color.GREEN.withAlpha(0.4),
            closeTop: true,
            closeBottom: true
            }
        });
      
        return _polygon;
    }

    /**
     * 初始化场景位置
     */
    static createPolygon(coors,options) {
        let gradeColor={
           0:Color.RED,
            1:Color.ORANGE,
            2:Color.YELLOW,
            3:Color.BLUE
        };
        let _polygon=new Entity({
             show:true,
             name: options.name,
             polygon: {
              hierarchy: Cartesian3.fromDegreesArray(coors),
              extrudedHeight: options.height,
              material: gradeColor[options.grade].withAlpha(0.4),
              closeTop: true,
              closeBottom: true
            }
        });
        let polyPositions = _polygon.polygon.hierarchy.getValue(Cesium.JulianDate.now()).positions;
        let polyCenter = Cesium.BoundingSphere.fromPoints(polyPositions).center;
        polyCenter = Cesium.Ellipsoid.WGS84.scaleToGeodeticSurface(polyCenter);
        _polygon.position = polyCenter;
        if(options.showName===1){
            _polygon.label= {
                text : options.name,
                color :Color.fromCssColorString('#fff'),
                font:'normal 32px MicroSoft YaHei',
                showBackground : true,
                scale : 0.4,
                distanceDisplayCondition : new Cesium.DistanceDisplayCondition(10.0, 1000.0),
                disableDepthTestDistance : 10000.0,
                pixelOffset:new Cartesian2(-10, 30),
                eyeOffset:new Cartesian3(0,0,-100),
            };
        }
      
        return _polygon;
    }


    /**
     * 返回两点之间的直线距离
     * @param {*} pt0 
     * @param {*} pt1 
     */
    static getDistance(pt0, pt1) {
        let distance = 0
            // Cartesian3.distance 计算的是两点之间的直线距离，忽略了地球曲率，不太合理。
        let s = Cartesian3.distance(pt0, pt1)
        distance = distance + s
        return distance
    }

    /**
     * 返回两点之间的测地距离。
     * @param {Cartesian3} pt1 第一个坐标点
     * @param {Cartesian3} pt2 第二个坐标点
     * @returns {Number} 返回两点之间的测地距离。
     */
    static getGeodesicDistance(pt1, pt2) {
        const pickedPointCartographic = Ellipsoid.WGS84.cartesianToCartographic(
            pt1
        )
        const lastPointCartographic = Ellipsoid.WGS84.cartesianToCartographic(
            pt2
        )
        const geodesic = new EllipsoidGeodesic(
            pickedPointCartographic,
            lastPointCartographic
        )
        return geodesic.surfaceDistance
    }

    /**
     * 改变primitive高度
     * @param {Number} height   高度
     * @param {Primitive} tileset  Primitive对象
     */
    static changeHeight(height, tileset) {
        height = Number(height);
        if (isNaN(height)) {
            return;
        }
        var cartographic = Cartographic.fromCartesian(tileset.boundingSphere.center);
        var surface = Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
        var offset = Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, height);
        var translation = Cartesian3.subtract(offset, surface, new Cartesian3());
        tileset.modelMatrix = Matrix4.fromTranslation(translation);
    }



    /**
     * WGS84坐标系转笛卡尔坐标系
     * @param point
     * @return {{x: *, y: *, z: *}}
     * @constructor
     */
    static WGS84_to_Cartesian3(point) {
        var car33 = Cartesian3.fromDegrees(point.lng, point.lat, point.alt);
        var x = car33.x;
        var y = car33.y;
        var z = car33.z;
        return new Cartesian3(x, y, z);
    }

    /**
     * 笛卡尔坐标系转WGS84坐标系
     * @param point
     * @return {{lat: *, lng: *, alt: *}}
     * @constructor
     */
    static Cartesian3_to_WGS84(cartesian33) {
        var cartographic = Cartographic.fromCartesian(cartesian33);
        var lat = cesiumMath.toDegrees(cartographic.latitude);
        var lng = cesiumMath.toDegrees(cartographic.longitude);
        var alt = cartographic.height;
        return [lng,lat,alt]
    }

    /**
     * WGS84坐标转换到屏幕坐标
     * @param {*} scene 
     * @param {*} point 
     */
    static WGS84_to_WindowCoordinates(scene, point) {
        let car33 = Cartesian3.fromDegrees(point.lng, point.lat, point.alt);
        return SceneTransforms.wgs84ToWindowCoordinates(scene, car33);
    }

    // 调整3D tiles位置
    static update3dtilesMaxtrix(tileset, tx, ty, tz, rx, ry, rz) {
        /**
         * 具体思路:
         * 1.保存原始矩阵:为了能从每个模型的矩阵参数中拿到平移参数
         * 2.重置模型位置(矩阵):将所有模型更新到同一坐标位置(矩阵)之后，相对位置会改变；
         * 3.纠正位置(矩阵):提取原始矩阵平移参数，对各自模型的矩阵进行位置纠正转换
         */
        // console.log('tileset.root.transform', tileset.root.transform);
        // console.log('tileset.modelMatrix', tileset.modelMatrix);
        // // 提前保存每个模型各自的矩阵参数,包含了偏移量；
        // let originTransform = tileset.root.transform;
        // // 获取所提供的矩阵的平移部分
        // let translation1 = Matrix4.getTranslation(tileset.root.transform, new Cartesian3());
        // console.log('translation1', translation1);
        // let translation1Mat = Matrix4.fromTranslation(translation1, new Matrix4())
        //     // console.log('translation1Mat', translation1Mat);
        //     // let tranInverse = Matrix4.inverse(translation1Mat, new Matrix4());
        //     // console.log('tranInverse', tranInverse);


        var params = {
            tx: tx, //模型中心X轴坐标（经度，单位：十进制度）
            ty: ty, //模型中心Y轴坐标（纬度，单位：十进制度）
            tz: tz, //模型中心Z轴坐标（高程，单位：米）
            rx: rx, //X轴（经度）方向旋转角度（单位：度）
            ry: ry, //Y轴（纬度）方向旋转角度（单位：度）
            rz: rz //Z轴（高程）方向旋转角度（单位：度）
        };
        // //旋转
        var mx = Matrix3.fromRotationX(cesiumMath.toRadians(params.rx));
        var my = Matrix3.fromRotationY(cesiumMath.toRadians(params.ry));
        var mz = Matrix3.fromRotationZ(cesiumMath.toRadians(params.rz));
        var rotationX = Matrix4.fromRotationTranslation(mx);
        var rotationY = Matrix4.fromRotationTranslation(my);
        var rotationZ = Matrix4.fromRotationTranslation(mz);
        // //平移  该平移操作是将整个模型平移到某点
        var position = Cartesian3.fromDegrees(params.tx, params.ty, params.tz);
        var m = Transforms.eastNorthUpToFixedFrame(position);


        //旋转、 平移矩阵相乘
        Matrix4.multiply(m, rotationX, m);
        Matrix4.multiply(m, rotationY, m);
        Matrix4.multiply(m, rotationZ, m);

        tileset.root.transform = m;



        // test();
        function test() {
            // const m1 = Transforms.eastNorthUpToFixedFrame(Matrix4.getTranslation(tileset.root.transform, new Cartesian3()), Ellipsoid.WGS84, new Matrix4());
            // const m3 = Matrix4.multiply(Matrix4.inverse(m1, new Matrix4()), tileset.root.transform, new Matrix4());
            // const mat3 = Matrix4.getMatrix3(m3, new Matrix3());
            // const q = Quaternion.fromRotationMatrix(mat3);
            // const hpr = HeadingPitchRoll.fromQuaternion(q);
            // const headingPitchRoll = new HeadingPitchRoll(hpr.heading, hpr.pitch, hpr.roll); // 获取当前模型heading，pitch，roll
            // var cartesian = Cartesian3.fromDegrees(params.tx, params.ty, params.tz); // 获取鼠标移动后的点
            // const m = Transforms.headingPitchRollToFixedFrame(cartesian, headingPitchRoll, Ellipsoid.WGS84, Transforms.eastNorthUpToFixedFrame, new Matrix4());

            const m = Transforms.eastNorthUpToFixedFrame(Matrix4.getTranslation(tileset.root.transform, new Cartesian3()), Ellipsoid.WGS84, new Matrix4());
            // //旋转
            var mx = Matrix3.fromRotationX(cesiumMath.toRadians(params.rx));
            var my = Matrix3.fromRotationY(cesiumMath.toRadians(params.ry));
            var mz = Matrix3.fromRotationZ(cesiumMath.toRadians(params.rz)); //  初步怀疑每一个模型的建模中心不一样，即本地坐标中心点不一样
            var rotationX = Matrix4.fromRotationTranslation(mx);
            var rotationY = Matrix4.fromRotationTranslation(my);
            var rotationZ = Matrix4.fromRotationTranslation(mz);
            // //平移  该平移操作是将整个模型平移到某点
            // var position = Cartesian3.fromDegrees(params.tx, params.ty, params.tz);
            // var m = Transforms.eastNorthUpToFixedFrame(position);
            // var m = tileset.root.transform;
            // let m = Transforms.eastNorthUpToFixedFrame(Matrix4.getTranslation(tileset.root.transform, new Cartesian3()), Ellipsoid.WGS84, new Matrix4());
            // Matrix4.multiply(m, translation1Mat, m);
            // // console.log('m', m);
            //旋转、平移矩阵相乘
            Matrix4.multiply(m, rotationX, m);
            Matrix4.multiply(m, rotationY, m);
            Matrix4.multiply(m, rotationZ, m);


            tileset.root.transform = m;
            console.log('m', m);
        }

        // 第二种
        // var boundingSphere = tileset.boundingSphere;
        // var catographic = Cartographic.fromCartesian(boundingSphere.center);
        // var surface = Cartesian3.fromRadians(catographic.longitude, catographic.latitude, 0.0);
        // var offset = Cartesian3.fromDegrees(params.x, params.y, params.z);
        // var translation = Cartesian3.subtract(offset, surface, new Cartesian3());
        // //旋转
        // var mx = Matrix3.fromRotationX(cesiumMath.toRadians(params.rx));
        // var my = Matrix3.fromRotationY(cesiumMath.toRadians(params.ry));
        // var mz = Matrix3.fromRotationZ(cesiumMath.toRadians(params.rz));
        // var rotationX = Matrix4.fromRotationTranslation(mx);
        // var rotationY = Matrix4.fromRotationTranslation(my);
        // var rotationZ = Matrix4.fromRotationTranslation(mz);
        // //旋转、平移矩阵相乘
        // Matrix4.multiply(m, rotationX, m);
        // Matrix4.multiply(m, rotationY, m);
        // Matrix4.multiply(m, rotationZ, m);
        // // tileset.root.transform = m;

        // let translation1 = Matrix4.getTranslation(tileset.root.transform, new Cartesian3())
        // console.log('translation', translation1);



        // const m1 = Transforms.eastNorthUpToFixedFrame(Matrix4.getTranslation(tileset.modelMatrix, new Cartesian3()), Ellipsoid.WGS84, new Matrix4());
        // const m3 = Matrix4.multiply(Matrix4.inverse(m1, new Matrix4()), tileset.modelMatrix, new Matrix4());
        // const mat3 = Matrix4.getRotation(m3, new Matrix3());
        // const q = Quaternion.fromRotationMatrix(mat3);
        // const hpr = HeadingPitchRoll.fromQuaternion(q);
        // const headingPitchRoll = new HeadingPitchRoll(hpr.heading, hpr.pitch, hpr.roll); // 获取当前模型heading，pitch，roll
        // var cartesian = Cartesian3.fromDegrees(params.tx, params.ty, params.tz);
        // const m = Transforms.headingPitchRollToFixedFrame(cartesian, headingPitchRoll, Ellipsoid.WGS84, Transforms.eastNorthUpToFixedFrame, new Matrix4());
        // tileset.modelMatrix = m;


    }

    static rad2deg(rad){
        return rad*180/Math.PI;
    }
    static deg2rad(degree){
        return degree*Math.PI/180;
    }
    static update3dtilesMaxtrix_yuanshi(tileset, tx, ty, tz, rx, ry, rz,_scale) {
       
        /**
         * 具体思路:
         * 1.保存原始矩阵:为了能从每个模型的矩阵参数中拿到平移参数
         * 2.重置模型位置(矩阵):将所有模型更新到同一坐标位置(矩阵)之后，相对位置会改变；
         * 3.纠正位置(矩阵):提取原始矩阵平移参数，对各自模型的矩阵进行位置纠正转换
         */
        // console.log('tileset.root.transform', tileset.root.transform);
        // console.log('tileset.modelMatrix', tileset.modelMatrix);
        // 提前保存每个模型各自的矩阵参数,包含了偏移量；
        let originTransform = tileset.root.transform;
        var params = {
            tx: tx, //模型中心X轴坐标（经度，单位：十进制度）
            ty: ty, //模型中心Y轴坐标（纬度，单位：十进制度）
            tz: tz, //模型中心Z轴坐标（高程，单位：米）
            rx: rx, //X轴（经度）方向旋转角度（单位：度）
            ry: ry, //Y轴（纬度）方向旋转角度（单位：度）
            rz: rz //Z轴（高程）方向旋转角度（单位：度）
        };

        //旋转
        var mx = Matrix3.fromRotationX(cesiumMath.toRadians(params.rx));
        var my = Matrix3.fromRotationY(cesiumMath.toRadians(params.ry));
        var mz = Matrix3.fromRotationZ(cesiumMath.toRadians(params.rz));
        var rotationX = Matrix4.fromRotationTranslation(mx);
        var rotationY = Matrix4.fromRotationTranslation(my);
        var rotationZ = Matrix4.fromRotationTranslation(mz);
        //平移  该平移操作是将整个模型平移到某点
        var position = Cartesian3.fromDegrees(params.tx, params.ty, params.tz);
        var m = Transforms.eastNorthUpToFixedFrame(position);

        //旋转、平移矩阵相乘
        Matrix4.multiply(m, rotationX, m);
        Matrix4.multiply(m, rotationY, m);
        Matrix4.multiply(m, rotationZ, m);



        var scale = Matrix4.fromUniformScale(_scale)
        Matrix4.multiply(m, scale, m)
        tileset.root.transform = m;
    }


    static saveUsefulFn(tileset, tx, ty, tz, rx, ry, rz) {
        // 得到模型的偏移位置
        let translation = Matrix4.getTranslation(tileset.modelMatrix)
    }


    // 防抖
    static debounce(fn, wait) {
        //用来记录当前执行函数的状态
        var timeout = null;

        return function() {
            if (timeout !== null) {
                //清除正在执行的函数
                clearTimeout(timeout);
            }
            timeout = setTimeout(fn, wait);
        }
    }
}
export default cesiumUtil;